<template>
    <div
        class="divide-y overflow-hidden rounded-lg shadow-sm bb-profile-block"
        :class="{ ['bb-component-background']: overrideBackground }"
    >
        <div v-if="title" class="px-4 py-5 sm:px-6">
            <div class="text-xl font-medium">{{ title }}</div>
        </div>
        <div class="px-4 py-5 sm:p-6">
            <slot></slot>
        </div>
        <div
            v-if="$slots['block-link']"
            class="px-4 py-4 sm:px-6 block-link text-center text-blue-500 cursor-pointer select-none"
        >
            <slot name="block-link"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Block",
    props: ["title", "overrideBackground"]
};
</script>

<style scoped>
.block-link > * {
    @apply w-full font-semibold px-4 py-2;
}
</style>
<style>
.bb-profile-block {
    background: var(--profile-card-background-color);
}
</style>
